import React, { useEffect, useState } from "react";
import { errorToast, successToast } from "../../Common/showtoast";
import ApiRequest from "../../Common/restservice";
import { useNavigate } from "react-router-dom";
import circlesvg from "../../Assets/Images/circle.svg";

function Editprofile({ stateObj, GetMyProfile }) {
  const navigate = useNavigate();

  // Initialize local state for the editable field (fullname)
  const [fullname, setFullname] = useState(stateObj.fullname || "");

  // Effect to sync local state with prop changes (e.g., after GetMyProfile runs)
  useEffect(() => {
    // Only update if the prop value is different
    if (stateObj.fullname !== fullname) {
      setFullname(stateObj.fullname || "");
    }
  }, [stateObj]); // Depend on stateObj

  const UpdateProfilePic = async (e) => {
    const formData = new FormData();
    formData.append("profileimage", e.target.files[0]);

    let res = await ApiRequest(
      "uploadprofileimg.asp",
      "POST",
      formData,
      { Authorization: localStorage.getItem("token") },
      false
    );

    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }

    // Refresh profile info to display the new image
    GetMyProfile();
    successToast(res.message);
  };

  const UpdateProfile = async () => {
    if (!fullname || fullname.trim().length < 2) {
      return errorToast("Enter a valid full name (at least 2 characters).");
    }

    // Use the current value of the local state for the update
    const updatedProfile = { ...stateObj, fullname: fullname.trim() };
    const data = JSON.stringify(updatedProfile);

    let res = await ApiRequest(
      localStorage.getItem("usertypecategory") === "Individual"
        ? "editprofile_freelancer.asp"
        : "editprofile_company.asp",
      "POST",
      data,
      { Authorization: localStorage.getItem("token") }
    );

    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }

    successToast(res.message);

    // Refresh profile info after successful update. This will eventually update stateObj.
    GetMyProfile();
  };

  return (
    <div className="card mb-0">
      <div className="card-header">
        <h3 className="card-title">Dashboard</h3>
      </div>
      <div className="card-body">
        <div className="row">

          {/* PACKAGE CARD */}
          <div className="col-md-4 stretch-card grid-margin mb-5">
            <div className="card bg-gradient-success card-img-holder text-white">
              <div className="card-body">
                <img
                  src={circlesvg}
                  className="card-img-absolute"
                  alt="circle"
                />
                <h4 className="font-weight-normal mb-3">
                  Package
                  <i className="mdi mdi-chart-line mdi-24px float-right"></i>
                </h4>
                <h3 className="mb-5">
                  {stateObj.activestatus === "Active"
                    ? stateObj.usertypecategory?.toLowerCase() === "company"
                      ? "Business"
                      : "Pro"
                    : "Free Listing"}
                </h3>
                <h6 className="card-text">Date : {stateObj.joiningdate}</h6>
              </div>
            </div>
          </div>

          {/* ACTIVATION CARD */}
          <div className="col-md-4 stretch-card grid-margin mb-5">
            <div className="card bg-gradient-info card-img-holder text-white">
              <div className="card-body">
                <img
                  src={circlesvg}
                  className="card-img-absolute"
                  alt="circle"
                />
                <h4 className="font-weight-normal mb-3">
                  Activation
                  <i className="mdi mdi-chart-line mdi-24px float-right"></i>
                </h4>
                <h2
                  className={`mb-5 btn ${stateObj.activestatus === "Inactive"
                    ? "btn-outline-danger"
                    : "btn-outline-success"
                    }`}
                >
                  {stateObj.activestatus}
                </h2>
                <h6 className="card-text">
                  Date : {stateObj.activationdate || "-"}
                </h6>
              </div>
            </div>
          </div>

          {/* EXPIRATION CARD */}
          <div className="col-md-4 stretch-card grid-margin mb-5">
            <div className="card bg-gradient-danger card-img-holder text-white">
              <div className="card-body">
                <img
                  src={circlesvg}
                  className="card-img-absolute"
                  alt="circle"
                />
                <h4 className="font-weight-normal mb-3">
                  Expires In
                  <i className="mdi mdi-chart-line mdi-24px float-right"></i>
                </h4>
                {stateObj.renewaldays ? (
                  <h2 className="mb-5">{stateObj.renewaldays} Days</h2>
                ) : (
                  <h2 className="mb-5">Non - Expiring</h2>
                )}
                <h6 className="card-text">Date : {stateObj.renewaldate || "-"}</h6>
              </div>
            </div>
          </div>

          {/* FULL NAME EDIT */}
          <div className="col-sm-6 col-md-6">
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Full Name"
                  // Update local state on change
                  onChange={(e) => setFullname(e.target.value)}
                  // Bind to local state
                  value={fullname}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={UpdateProfile}
                >
                  Update
                </button>
              </div>
            </div>
          </div>

          {/* EMAIL DISPLAY */}
          <div className="col-sm-6 col-md-6">
            <div className="form-group">
              <label className="form-label">Email address</label>
              <input
                type="email"
                value={stateObj.email || ""}
                className="form-control"
                readOnly
                placeholder="Email"
              />
            </div>
          </div>

          {/* PHONE DISPLAY */}
          <div className="col-sm-6 col-md-6">
            <div className="form-group">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                value={stateObj.mobile || ""}
                className="form-control"
                readOnly
                placeholder="Number"
              />
            </div>
          </div>

          {/* PROFILE PICTURE UPLOAD */}
          <div className="col-md-6">
            <div className="form-group mb-0">
              <label className="form-label">Upload Profile Picture</label>
              <div className="form-file">
                <input
                  type="file"
                  className="form-control example-file-input-custom"
                  accept="image/jpg,image/jpeg"
                  id="profilepic"
                  name="profilepic"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      UpdateProfilePic(e);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Editprofile;